export default "__VITE_ASSET__CxzTyrmI__"